import { OutputData } from "@editorjs/editorjs";

import { FIELDS, FieldsGroup } from "../../fields.d";

export type FormInputs = {
  title: string;
  slug: string;
  lead: string;
  type?: string;
  types?: { id: string; label?: string }[];
  source: string;
  duration: number | string;
  thumbnailUrl: string;
  isFeaturedOnHomePage: boolean;
  isBlockedFromHomePage: boolean;
  publishedAt?: any;
  tagIds?: number[];
  tags?: { id: number; label?: string }[];
  content?: Record<string, any>[];
  labels?: { id: number; label?: string }[];
  labelIds?: number[];
  editors?: { id: number; label?: string }[];
  editorId?: number;
  games?: { id: number; label?: string }[];
  gameId?: number;
  body?: OutputData[];
  trackingCode?: string;
  brands?: { id: string; label?: string }[];
  brand?: string;
};

export const VIDEOS_FIELDS: FieldsGroup[] = [
  {
    id: "publication",
    label: "Publikacja",
    fields: [
      {
        id: "publishedAt",
        label: "",
        type: FIELDS.DateTimePicker,
        dataType: "datetime",
        span: 12,
        show: { visible: true },
        create: { visible: true },
        edit: { visible: true },
      },
    ],
  },
  {
    id: "basicInfo",
    label: "Podstawowe informacje",
    fields: [
      {
        id: "title",
        label: "Tytuł",
        type: FIELDS.Input,
        span: 12,
        show: { visible: true },
        create: { visible: true, required: true },
        edit: { visible: true, required: true },
      },
      {
        id: "slug",
        label: "Slug",
        type: FIELDS.Input,
        span: 12,
        show: { visible: true },
        create: { visible: true, required: true },
        edit: { visible: true, required: true },
      },
      {
        id: "lead",
        label: "Lead",
        type: FIELDS.TextArea,
        span: 12,
        show: { visible: true },
        create: { visible: true },
        edit: { visible: true },
      },
      {
        id: "duration",
        label: "Długość",
        type: FIELDS.Input,
        dataType: "duration",
        span: 3,
        placeholder: "HH:MM:SS",
        mask: "99:99:99",
        show: { visible: true },
        create: { visible: true, required: true },
        edit: { visible: true, required: true },
      },
      {
        id: "types",
        label: "Typ",
        type: FIELDS.VideoTypesSelect,
        span: 3,
        show: { visible: false },
        create: { visible: true, required: true },
        edit: { visible: true, required: true },
      },
      {
        id: "type",
        label: "Typ",
        type: FIELDS.Input,
        dataType: "video-type",
        span: 3,
        show: { visible: true },
        create: { visible: false },
        edit: { visible: false },
      },
      {
        id: "createdAt",
        label: "Data utworzenia",
        type: FIELDS.Input,
        dataType: "datetime",
        span: 3,
        show: { visible: true },
        create: { visible: false },
        edit: { visible: false },
      },
      {
        id: "updatedAt",
        label: "Data aktualizacji",
        type: FIELDS.Input,
        dataType: "datetime",
        span: 3,
        show: { visible: true },
        create: { visible: false },
        edit: { visible: false },
      },
      {
        id: "source",
        label: "Źródło",
        type: FIELDS.Input,
        span: 12,
        dataType: "external",
        show: { visible: true },
        create: { visible: true, required: true },
        edit: { visible: true, required: true },
      },
      {
        id: "editors",
        label: "Redaktor",
        type: FIELDS.EditorsSelect,
        span: 4,
        show: { visible: false },
        create: { visible: true, required: true },
        edit: { visible: true, required: true },
      },
      {
        id: "editorId",
        label: "Redaktor",
        type: FIELDS.Input,
        dataType: "model:editors",
        span: 6,
        show: { visible: true, accessor: ["editor", "nick"] },
        create: { visible: false },
        edit: { visible: false },
      },
      {
        id: "brands",
        label: "Marka",
        type: FIELDS.BrandSelect,
        span: 3,
        dataType: "brand",
        show: { visible: false },
        create: { visible: true, required: true },
        edit: { visible: true, required: true },
      },
      {
        id: "brand",
        label: "Marka",
        type: FIELDS.Input,
        span: 3,
        dataType: "brand",
        show: { visible: true },
        create: { visible: false },
        edit: { visible: false },
      },
    ],
  },
  {
    id: "attribites",
    label: "Atrybuty",
    fields: [
      {
        id: "isFeaturedOnHomePage",
        label: "Wyróżnienie na stronie głównej",
        type: FIELDS.Checkbox,
        dataType: "boolean",
        span: 4,
        show: { visible: true },
        create: { visible: true },
        edit: { visible: true },
      },
      {
        id: "isBlockedFromHomePage",
        label: "Blokowanie na stronie głównej",
        type: FIELDS.Checkbox,
        dataType: "boolean",
        span: 4,
        show: { visible: true },
        create: { visible: true },
        edit: { visible: true },
      },
    ],
  },
  {
    id: "content",
    label: "Treść",
    fields: [
      {
        id: "body",
        label: "",
        span: 12,
        type: FIELDS.Editor,
        show: { visible: true },
        create: { visible: true },
        edit: { visible: true },
      },
      {
        id: "trackingCode",
        label: "Kod śledzenia",
        caption: "Ukryty kod HTML niewidoczny dla użytkownika.",
        span: 12,
        type: FIELDS.TextArea,
        show: { visible: true },
        create: { visible: true },
        edit: { visible: true },
      },
    ],
  },
  {
    id: "bindings",
    label: "Powiązania",
    fields: [
      {
        id: "games",
        label: "Karta gry",
        span: 12,
        dataType: "model:games",
        type: FIELDS.GamesSelect,
        show: { visible: true, accessor: ["game", "originalTitle"] },
        create: { visible: true },
        edit: { visible: true },
      },
    ],
  },
  {
    id: "tags",
    label: "Tagi",
    fields: [
      {
        id: "tags",
        label: "",
        type: FIELDS.TagsSelect,
        span: 12,
        show: { visible: false },
        create: { visible: true },
        edit: { visible: true },
      },
      {
        id: "labels",
        label: "Etykiety",
        type: FIELDS.LabelsSelect,
        span: 12,
        show: { visible: false },
        create: { visible: true },
        edit: { visible: true },
      },
    ],
  },
  {
    id: "thumbnail",
    label: "Miniatura",
    fields: [
      {
        id: "thumbnailUrl",
        label: "",
        type: FIELDS.ImagePicker,
        span: 12,
        show: { visible: false },
        create: { visible: true },
        edit: { visible: true },
      },
    ],
  },
];
